module.exports = __webpack_public_path__ + "img/product_71.90ddb2e.webp";